interface SideMenuNavItemProps {
  id?: string;
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  isSelected?: boolean;
}

export default function SideMenuNavItem({
  id,
  icon,
  label,
  onClick,
  isSelected,
}: SideMenuNavItemProps) {
  return (
    <button
      id={id}
      className={`w-full py-2 px-2 rounded-lg
        ${isSelected ? "bg-dark-surface-secondary" : ""}
        hover:bg-dark-hover cursor-pointer transition-colors`}
      onClick={onClick}
    >
      <div className="grid grid-cols-[24px_1fr] items-center gap-3">
        <div className="flex items-center justify-center">{icon}</div>
        <span className="text-sm font-medium text-dark-text text-left">
          {label}
        </span>
      </div>
    </button>
  );
}
